import type { ReactNode } from 'react'
import './bits.css'

export function ProgressBar({ ratio, label }: { ratio: number; label?: string }) {
  const pctVal = Math.round(Math.min(1, Math.max(0, ratio)) * 100)
  return (
    <div
      className="progressbar"
      role="progressbar"
      aria-valuenow={pctVal}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className="progressbar__track">
        <div className="progressbar__fill" style={{ width: `${pctVal}%` }} />
      </div>
      {label ? <span className="progressbar__label tnum">{label}</span> : null}
    </div>
  )
}

export function StatTile({
  label,
  value,
  sub,
}: {
  label: string
  value: ReactNode
  sub?: ReactNode
}) {
  return (
    <div className="stattile">
      <div className="stattile__label">{label}</div>
      <div className="stattile__value tnum">{value}</div>
      {sub ? <div className="stattile__sub">{sub}</div> : null}
    </div>
  )
}

export function NexOrganixMark({ size = 20 }: { size?: number }) {
  return <img className="nx-mark" src="/nexorganix-mark.png" height={size} alt="" aria-hidden />
}

export function NexOrganixLogo({ height = 30 }: { height?: number }) {
  return (
    <span className="nx-logo-chip">
      <img className="nx-logo" src="/nexorganix-logo.png" height={height} alt="NexOrganix" />
    </span>
  )
}

export function NexOrganixFooter() {
  return (
    <footer className="nx-footer">
      <span>Tillhandahålls av</span>
      <NexOrganixLogo height={24} />
    </footer>
  )
}
